export const COMPANY = {
  name: "Go Deliver",
  country: "United Kingdom",
  phone: "+447448143938",
  email: "Godelivery_jsh2026@aol.com",
  tagline: "Freight & parcel tracking, built for speed and zero guesswork.",
};

const W = "&w=1600&q=80";
export const MEDIA = {
  terminalAerial: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  shipPort: "https://images.unsplash.com/photo-1724364552281-dbed323c4633?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  containerStacks: "https://images.unsplash.com/photo-1606964212858-c215029db704?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  courierVan: "https://images.unsplash.com/photo-1696592783645-33e966c4c274?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  warehouseTablet: "https://images.unsplash.com/photo-1781559818983-c32838ee3d55?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  cargoPlane: "https://images.unsplash.com/photo-1774698078446-59299e016718?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
  courierWalk: "https://images.unsplash.com/photo-1764792314927-a82d9996285f?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0" + W,
};

export const LIVE_FEEDS = [
  { id: "HUB-01", label: "Hub 01 — Container Yard", city: "London, UK", img: MEDIA.terminalAerial },
  { id: "DC-04", label: "DC 04 — Inbound Sort Dock", city: "Manchester, UK", img: MEDIA.warehouseTablet },
  { id: "RTE-14", label: "Route 14 — Last Mile", city: "Birmingham, UK", img: MEDIA.courierVan },
  { id: "AIR-02", label: "Air Gateway 02 — Freight Ramp", city: "East Midlands, UK", img: MEDIA.cargoPlane },
];

export const FOOTER_SECTIONS = [
  {
    title: "OUR COMPANY",
    links: [
      { label: "About Go Deliver", to: "/about" },
      { label: "Our Portfolio", to: "/portfolio" },
      { label: "Investor Relations", to: "/info/investor-relations" },
      { label: "Careers", to: "/info/careers" },
      { label: "Transportation Contracting Opportunities", to: "/info/contracting" },
      { label: "Blog", to: "/info/blog" },
      { label: "Corporate Responsibility", to: "/info/corporate-responsibility" },
      { label: "Newsroom", to: "/info/newsroom" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
  {
    title: "MORE",
    links: [
      { label: "Developer Portal", to: "/info/developer-portal" },
      { label: "Logistics", to: "/info/logistics" },
    ],
  },
  {
    title: "POLICY CENTER",
    links: [
      { label: "Terms of Use", to: "/info/terms" },
      { label: "Privacy & Security", to: "/info/privacy" },
      { label: "Ad Choices", to: "/info/ad-choices" },
      { label: "Your Privacy Choices", to: "/info/privacy-choices" },
    ],
  },
];

export const INFO_CONTENT = {
  "investor-relations": {
    title: "Investor Relations",
    intro: "Transparency and long-term value creation for every Go Deliver stakeholder.",
    body: [
      "Go Deliver delivers consistent growth across freight, parcel and last-mile logistics. Our investor program keeps shareholders informed with quarterly operational updates, shipment-volume metrics and network expansion milestones.",
      "For earnings releases, governance documents and the annual report, reach our IR desk at the contact details below.",
    ],
  },
  careers: {
    title: "Careers at Go Deliver",
    intro: "Move the world forward. Build your career on the network that never sleeps.",
    body: [
      "From hub operations and courier routes to engineering the tracking platform you're using now, Go Deliver hires people who care about getting every parcel to the right door, on time.",
      "We are hiring across operations, driving, warehouse and technology roles. Send your CV to our careers team using the contact details below.",
    ],
  },
  contracting: {
    title: "Transportation Contracting Opportunities",
    intro: "Partner with Go Deliver as an owner-operator or contracted carrier.",
    body: [
      "We work with independent carriers and fleet owners to expand regional capacity. Contracted partners gain access to steady freight volume, route optimisation and same-day settlement.",
      "To register your fleet, contact our carrier onboarding team.",
    ],
  },
  blog: {
    title: "Go Deliver Blog",
    intro: "Insights on logistics, supply chain and the future of delivery.",
    body: [
      "Stories from the network: how real-time tracking cuts failed deliveries, lessons from peak season, and the technology powering faster last-mile handoffs.",
      "New articles publish every week.",
    ],
  },
  "corporate-responsibility": {
    title: "Corporate Responsibility",
    intro: "Delivering responsibly — for people and the planet.",
    body: [
      "Go Deliver is committed to greener fleets, optimised routing that reduces empty miles, and investing in the communities our couriers serve.",
      "Read about our emissions-reduction roadmap and community programs.",
    ],
  },
  newsroom: {
    title: "Newsroom",
    intro: "The latest announcements and press from Go Deliver.",
    body: [
      "Media enquiries, press releases and brand assets. For interviews and statements, contact our communications desk below.",
    ],
  },
  "developer-portal": {
    title: "Developer Portal",
    intro: "Build on the Go Deliver tracking network.",
    body: [
      "Integrate shipment creation, status webhooks and public tracking into your own apps. Our REST API mirrors the platform you see here — create shipments, push status updates and resolve tracking numbers programmatically.",
      "Request API access through the contact details below to receive your developer key.",
    ],
  },
  logistics: {
    title: "Go Deliver Logistics",
    intro: "End-to-end freight, warehousing and fulfilment.",
    body: [
      "Beyond parcels, Go Deliver Logistics offers managed warehousing, intermodal freight (road, rail, sea and air) and fulfilment for businesses of every size.",
      "Talk to our logistics team to design a supply-chain solution for you.",
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "The rules for using Go Deliver services and this website.",
    body: [
      "By accessing Go Deliver you agree to use the service lawfully and only for legitimate shipment tracking and management. Tracking information is provided for convenience and may be updated as shipments progress.",
      "Accounts must not be shared and admin access is granted by invitation only.",
    ],
  },
  privacy: {
    title: "Privacy & Security",
    intro: "How we protect your data.",
    body: [
      "We store only what we need to operate your shipments. Passwords are hashed with bcrypt, sessions use secure httpOnly cookies, and the public tracking page exposes only minimal, non-personal fields.",
      "We never sell your personal data.",
    ],
  },
  "ad-choices": {
    title: "Ad Choices",
    intro: "Your choices about advertising.",
    body: [
      "Go Deliver does not run third-party advertising inside your tracking dashboard. Any future marketing communications are opt-in and can be turned off at any time.",
    ],
  },
  "privacy-choices": {
    title: "Your Privacy Choices",
    intro: "Control how your information is used.",
    body: [
      "You can request access to, correction of, or deletion of your personal data at any time. To exercise your privacy choices, contact us using the details below.",
    ],
  },
};
